<template>
  <div class="delivery-method payment">
    <div class="row">
      <div class="col-xs-12">
        <div class="row center-xs">
          <div class="col-xs-12 cl-mine-shaft" >
            <h3 class="h4 m0 lh35">
              {{ $t('Payment') }}
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div class="row pt10">
      <div class="col-xs-12">
        <div class="row">
          <div class="relative radius col-xs-12 card-wrapper">
            <div class="flex center-xs card" v-for="(method, index) in paymentMethods" :key="index">
              <label v-if="!isGiftPartner && !(method.code !== 'cash' && isPickup)" class="flex w-100 middle-sm"
                     :class="{
                         'is-checked' : method.code === payment.paymentMethod,
                         'disable-credit-card-online' : method.code === 'ipay_masterpass' && !user,
                         'space-bank-number' : payment.paymentMethod === 'card' &&
                         currentLocation && currentLocation.hasOwnProperty('bankcard_number') && !currentLocation.bankcard_number,
                         'disabled-pickup': method.code !== 'cash' && isPickup
                       }"
              >
                <div class="relative pointer w-100" @click="selectMethod(method.code)">
                  <div class="payments w-100" v-if="!checkGoogleAndApplePay(method.code)">
                    <i class="material-icons w-100" >{{ method.img }}</i>
                    <span class="w-100">{{ $t(method.title) }}</span>
                  </div>
                  <div v-else class="payments online-payment">
                    <div>
                      <img
                        class="google-pay-button"
                        v-if="method.code === 'ipay_gpay'"
                        width="112"
                        height="64"
                        src="/assets/payment/google-pay-mark.svg"
                        alt="Google pay"
                        loading="lazy"
                        fetchpriority="auto"
                      >
                      <div v-if="method.code === 'ipay_applepay'">
                        <img v-if="method.code === payment.paymentMethod" width="20" height="20" src="/assets/payment/apple-white.png" alt="Apple pay" loading="lazy" fetchpriority="auto">
                        <img v-else width="20" height="20" src="/assets/payment/apple-black.png" alt="Apple pay" loading="lazy" fetchpriority="auto">
                        Pay
                      </div>
                    </div>
                  </div>
                  <div class="autorization-message" v-if="!method.offline && !user && !isPickup">
                    <div>
                      <span @click="loginOrRegister('register')" class="button-login-and-register-for-iPay mt5">{{ $t('register') }}</span>
                      {{ $t("or") }}
                      <span @click="loginOrRegister('login')" class="button-login-and-register-for-iPay">{{ $t('login to your account') }}</span>
                    </div>
                  </div>
                </div>
              </label>
            </div>
          </div>
          <div class="col-md-12 mt16" v-if="isOnlinePaymentMethodSelected">
            <div v-if="isUserValidationFailed && user && !isPickup"
                 class="col-md-12 start-md message-disable-credit-card-online">
              {{ $t('Error happened during data loading. Probably your phone number used in another account') }}
            </div>
            <div v-if="!getPhoneNumber(true) && user && !isPickup"
                 class="col-md-12 start-md message-disable-credit-card-online">
              {{ $t('We need your phone number to process online payments. Please, add it in the field above') }}
            </div>
          </div>
          <div class="col-md-12 mt16" v-if="payment.paymentMethod === 'cash'">
            <base-input
              class="banknotes"
              type="text"
              autocomplete="address-line3"
              :placeholder="$t('Enter the denomination of the bill for calculation (500, 1000)')"
              v-model="payment.banknoteDenomination"
              @input="cashInputFilter"
              @beforeinput="cashPreventInvalidInput"
              :not-validate="true"
            />
          </div>
          <div class="col-md-12 start-md ml30 flex bank-cart"
               v-if="payment.paymentMethod === 'card' && currentLocation && currentLocation.hasOwnProperty('bankcard_number') && currentLocation.bankcard_number"
          >
            <img src="/assets/banknotes/privat-bank.png" alt="Private bank" width="28" height="28" loading="lazy" fetchpriority="auto">
            <div>{{ currentLocation.bankcard_number }}</div>
          </div>
          <default-credit-card class="ml0" v-if="payment.paymentMethod === 'ipay_masterpass' && !isUserValidationFailed && getPhoneNumber(true)" :location="currentLocation"/>
        </div>
      </div>
    </div>
    <modal-credit-cards-list />
    <otp-verification-modal />
  </div>
</template>

<script async>
import { required, minLength } from 'vuelidate/lib/validators'
import { unicodeAlphaNum } from '@vue-storefront/core/helpers/validators'
import { Payment } from '@vue-storefront/core/modules/checkout/components/Payment'
import { mapGetters } from 'vuex'
import 'swiper/css/swiper.css';

const OTPVerificationCodeModal = () => import(/* webpackChunkName: "vsf-otp-verification-code-modal" */ './Payment/OTPVerificationCodeModal');
const ModalCreditCardsList = () => import(/* webpackChunkName: "vsf-modal-credit-cards-list" */ './Payment/ModalCreditCardsList');
const DefaultCreditCard = () => import(/* webpackChunkName: "vsf-default-credit-card" */ './Payment/DefaultCreditCard');
const BaseInput = () => import(/* webpackChunkName: "vsf-base-input" */ 'theme/components/core/blocks/Form/BaseInput');

export default {
  components: {
    BaseInput,
    DefaultCreditCard,
    ModalCreditCardsList,
    'otp-verification-modal': OTPVerificationCodeModal
  },
  mixins: [Payment],
  props: {
    shippingMethods: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    loginOrRegister (payload) {
      this.$bus.$emit('modal-toggle', 'modal-signup')
      this.$store.commit('ui/setAuthElem', payload)
    },
    checkGoogleAndApplePay (payment) {
      return ['ipay_gpay', 'ipay_applepay'].includes(payment)
    },
    selectMethod (method) {
      const selectedPayment = this.paymentMethods.find(p => p.code === method)
      if (!selectedPayment.offline && !this.user && !this.isPickup) return
      this.payment.paymentMethod = method
      this.changePaymentMethod();
      this.sendDataToCheckout();
      this.$forceUpdate();
    },
    cashPreventInvalidInput (event) {
      if (event.inputType.includes('delete')) {
        return;
      }

      const lastChar = this.payment.banknoteDenomination.slice(-1);
      const newChar = event.data;

      if (!/^[0-9 .,]$/.test(event.data)) {
        event.preventDefault();
      }

      if (/[,.]/.test(newChar) && (!/[\d]/.test(lastChar) || lastChar === '')) {
        event.preventDefault();
      }

      if (newChar === ' ' && lastChar === ' ') {
        event.preventDefault();
      }
    },
    cashInputFilter (value) {
      this.payment.banknoteDenomination = value
        .replace(/[^0-9 .,]/g, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/([,.]){2,}/g, '$1');
    }
  },
  computed: {
    user () {
      return this.$store.state.user.current
    },
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation'
    }),
    isPickup () {
      return !!this.shippingMethods.find(shipping => (!!shipping && 'method' in shipping && shipping.method.method_code === 'pickup'))
    },
    isGiftPartner () {
      return this.partnersInCheckout.find(group => group.partner.code === 'gift')
    },
    partnersInCheckout () {
      return this.$store.getters['partners/getGroupedByPartnerProducts'];
    },
    isOnlinePaymentMethodSelected () {
      if (!this.payment.paymentMethod) {
        return false
      }
      const selectedPayment = this.paymentMethods.find(p => p.code === this.payment.paymentMethod)
      return selectedPayment && !selectedPayment.offline
    }
  },
  watch: {
    isPickup: {
      handler () {
        if (this.isPickup && !this.isGiftPartner) {
          this.payment.paymentMethod = 'cash'
          this.payment.houseNumber = '0'
          this.payment.streetAddress = 'pickup'
          this.$v.payment.paymentMethod.$touch();
          this.changePaymentMethod();
          this.sendDataToCheckout()
        }
      }
    },
    'payment.paymentMethod': {
      handler() {
        if (this.isPickup && this.payment.paymentMethod !== 'cash' && !this.isGiftPartner) {
          this.payment.paymentMethod = 'cash'
          this.$v.payment.paymentMethod.$touch();
          this.changePaymentMethod();
          this.sendDataToCheckout()
        }
      }
    },
    user: {
      handler () {
        if (!this.user && !this.isPickup) {
          this.payment.paymentMethod = null
          this.$v.payment.paymentMethod.$touch();
          this.changePaymentMethod();
          this.sendDataToCheckout()
        } else {
          this.payment.paymentMethod = 'cash'
          this.$v.payment.paymentMethod.$touch();
          this.changePaymentMethod();
          this.sendDataToCheckout();
        }
      }
    }
  },
  mounted () {
    if (this.isGiftPartner) {
      if (!this.user && !this.isPickup) {
        this.payment.paymentMethod = null
        this.$v.payment.paymentMethod.$touch();
        this.changePaymentMethod();
        this.sendDataToCheckout()
      } else {
        this.payment.paymentMethod = 'ipay_masterpass'
        this.$v.payment.paymentMethod.$touch();
        this.changePaymentMethod();
        this.sendDataToCheckout();
      }
    }
  },
  validations () {
    if (!this.shippingMethods.length) {
      return {
        payment: {
          paymentMethod: {}
        }
      }
    }
    for (let i = 0; i < this.shippingMethods.length; i++ ) {
      if (this.shippingMethods[i].method_code !== 'pickup') {
        if (!this.generateInvoice) {
          return {
            payment: {
              streetAddress: {
                // required,
                unicodeAlphaNum
              },
              houseNumber: {
                // required,
                unicodeAlphaNum
              },
              paymentMethod: {
                required
              }
            }
          }
        } else {
          return {
            payment: {
              company: {
                // required,
                unicodeAlphaNum
              },
              taxId: {
                // required,
                minLength: minLength(3)
              },
              streetAddress: {
                // required,
                unicodeAlphaNum
              },
              houseNumber: {
                // required,
                unicodeAlphaNum
              },
              paymentMethod: {
                required
              }
            }
          }
        }
      } else {
        return {
          payment: {
            paymentMethod: {}
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
.banknotes.base-input {
  min-height: 3.5rem;
  label {
    @media (max-width: 991px) {
      font-size: 13px;
    }
  }
}

.mt16 {
  margin-top: 16px;
}
</style>
<style scoped lang="scss">
@import '~theme/css/base/text';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$bg-secondary: color(secondary, $colors-background);
$color-tertiary: color(tertiary);
$color-secondary: color(secondary);
$color-error: color(error);
$color-white: color(white);
$color-black: color(black);
.bank-cart {
  align-items: center;
  height: 56px;
}
.radioStyled {
  display: flex;
  position: relative;
  padding-left: 0;
  margin-bottom: 0;
  height: 45px;
}
.delivery-method {
  .active-checkbox {
    width: 17px;
    height: 17px;
    border-radius: 15px;
    top: -1px;
    left: -5px;
    position: relative;
    background-color: #FFFFFF;
    content: '';
    display: inline-block;
    visibility: visible;
    border: 2px solid grey;
  }
  .is-checked {
    margin-bottom: 0;
    &.space-bank-number {
      margin-bottom: 56px!important;
    }
    .active-checkbox {
      &:after {
        width: 13px;
        height: 13px;
        border-radius: 15px;
        top: 2px;
        left: 2px;
        position: absolute;
        background-color: #11bb2e;
        content: '';
        display: inline-block;
        visibility: visible;
      }
    }
    border-radius: 10px;
    opacity: 1;
  }
  .radioStyled {
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      border: 1px solid #f9a000;

      &:after {
        content: "";
        position: absolute;
        display: none;
        top: 2px;
        left: 2px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: $color-secondary;
      }
    }

    input:checked ~ .checkmark:after {
      display: block;
    }
  }
  label{
    font-size: 13px;
    @media (min-width: 769px) {
      font-size: 16px;
      justify-content: center;
      margin: 0;
    }
  }

  input {
    opacity: 0;
    padding: 0;
    height: 0;
    width: 0;
  }
  .mr5{
    margin-right: 5px;
  }
  .disabled-pickup {
    color: #8e8e8e;
  }
}
.disable-credit-card-online {
  color: #8e8e8e;
}
.message-disable-credit-card-online {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.09px;
  color: #111111
}
.or-for-login-and-register {
  align-self: center;
}
.button-login-and-register-for-iPay {
  color: #11bb2e;
  text-decoration: underline;
  cursor: pointer;
}
.ml5 {
  margin-left: 5px;
}

.card-wrapper {
  display: flex;
  column-gap: 16px;
  row-gap: 6px;

  .card {
    flex: 1 1 33.33%;
  }

  @media only screen and (max-width: 991px) {
    flex-wrap: wrap;

    .card {
      flex: 1 1 calc(50% - 16px);
      max-width: calc(50% - 16px);
    }
  }
}
</style>
<style lang="scss" scoped>
  .payments {
    border: 1px solid #11bb2e;
    border-radius: 18px;
    padding: 20px 0;
    width: 100%;
    height: 50px;
    margin-top: 20px;

    @media only screen and  (max-width: 991px) {
      margin-top: 10px;
    }

    @media (max-width: 768px) {
      font-size: 18px;
      align-content: center;
      display: inline-grid;
      height: 40px;
    }
    span {
      font-size: 16px;
      @media (max-width: 768px) {
        display: none;
      }
    }
    i.material-icons {
      font-size: 27px;
      @media (max-width: 768px) {
        font-size: 32px;
      }
    }
    &.online-payment {
      display: flex;
      align-items: center;
      place-content: center;
      div {
        display: flex;
        align-items: center;
        font-size: 24px;
        @media (max-width: 768px) {
          font-size: 23px;
        }
        img {
          margin-right: 3px;
          @media (max-width: 768px) {
            width: 23px;
          }
          &.google-pay-button {
            width: 112px;
          }
        }
      }
    }
  }
  .delivery-method {
    .is-checked {
      .payments {
        background: #11bb2e;
        color: #fff;
      }
    }
  }
  .autorization-message {
    position: absolute;
    bottom: 1px;
    color: #11bb2e;
    font-weight: bold;
    height: 100%;
    width: 100%;
    left: 1px;
    border-radius: 17px;
    background: #000000ad;
    max-height: 70px;
    padding: 10px 0;
    span {
      display: block;
    }
    @media only screen and (max-width: 768px) {
      padding: 10px 0 0;
    }

    @media (max-width: 748px) {
      max-height: 70px;
    }
  }
  .ml0 {
    margin-left: 0;
  }
</style>
